<template lang="pug">

	button.btn.btn-sm(type='button', @click="draw()", :class=" !drawing ? 'btn-primary' : 'btn-danger' ") 
		i(:class=" !drawing ? iconClass : 'mdi mdi-window-close'")
		|  {{ label }}

</template>

<script>

import LeafletUtils from '@/utils/leafletUtils';

export default {
	
	name: 'DrawButton',

	props: {
		label: {
			type: String,
			default: 'Desenhar'
		},

		iconClass: {
			type: String,
			default: 'mdi mdi-lead-pencil'
		},

		addLayerToMap: {
			type: Boolean,
			default: true
		},

		drawTool: {
			type: String,
			required: true
		},

		setDetails: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			drawing: false
		};
	},

	methods: {

		draw () {

			if (this.drawing) {

				this.drawing = false;
				this.$bus.$emit('mapa.cancelDraw');
				return;
			}

			this.drawing = true;

			this.$bus.$emit('mapa.draw', {
				center: false,
				tool: this.drawTool,
				onComplete: (layer) => {
				
					this.drawing = false;

					if (!this.addLayerToMap) this.$mapa.removeLayer(layer);
					
					let result = { layer: layer };

					if (this.setDetails) this.setLayerDetails(result);

					this.$emit('drawComplete', result);
				},
				onCancel: () => {
					this.drawing = false;
				}
			});
		},

		setLayerDetails (result) {

			result.area = LeafletUtils.getLayerArea(result.layer);

			if (result.layer.getLatLng) {
				
				let latlng = result.layer.getLatLng();
				
				result.latlng = { lat: latlng.lat, lng: latlng.lng };
			}
		}
	}
};

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// DrawButton.vue?81c6d230